import { render } from "./orgUserGroupChoice.vue?vue&type=template&id=79fde57c&scoped=true"
import script from "./orgUserGroupChoice.vue?vue&type=script&lang=js"
export * from "./orgUserGroupChoice.vue?vue&type=script&lang=js"

import "./orgUserGroupChoice.vue?vue&type=style&index=0&id=79fde57c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fde57c"]])

export default __exports__